import { ReportingRoute } from '/@/modules/reporting/constants/ReportingRoute';

export const router = [
  {
    name: ReportingRoute.REPORTING,
    path: `/${ReportingRoute.REPORTING}`,
    component: () => import('/@/modules/reporting/pages/ReportingPage.vue'),
    children: [
      {
        path: ReportingRoute.FINANCIAL_INSIGHTS.path,
        name: ReportingRoute.FINANCIAL_INSIGHTS.name,
        component: () => import('/@/modules/reporting/pages/FinancialInsightsPage.vue')
      },
      {
        path: ReportingRoute.CUSTOM_REPORTS.path,
        name: ReportingRoute.CUSTOM_REPORTS.name,
        component: () => import('/@/modules/reporting/pages/CustomReportsPage.vue')
      }
    ]
  }
];
